import { render, staticRenderFns } from "./PosterRenderer.vue?vue&type=template&id=f5a81444"
import script from "./PosterRenderer.vue?vue&type=script&lang=js"
export * from "./PosterRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports